'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionNote', ['$scope', '$stateParams', '$state', 'Notes',
        function ($scope, $stateParams, $state, Notes) {
        $scope.resetInspection();
        $scope.inspection_note = $stateParams.inspection_note;
        $scope.inspectionNoteID = $stateParams.inspectionNoteID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        
        if ($stateParams.inspectionNoteID != null) {
            Notes.getByID($stateParams.inspectionNoteID).then(function (note) {
                $scope.inspection_note = note;
                $scope.loading = false;
            })
        }
        else {
            $scope.inspection_note = {};
            $scope.loading = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            Notes.save($scope.inspection_note, $scope.inspectionID).then(function (note) {
                updateArray($scope.inspection.notes, note);
                updateArray($scope.masterInspection.notes, note);
                $state.go('internal.inspecting.inspection.notes', { id: $scope.inspectionID });
                $scope.saving = false;
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            Notes.delete($stateParams.inspectionNoteID).then(function () {
                updateArray($scope.inspection.notes, $scope.inspection_note, true);
                updateArray($scope.masterInspection.notes, $scope.inspection_note, true);
                $scope.deleting = false;
                $state.go('internal.inspecting.inspection.notes', { id: $scope.inspectionID });
            })
        }
    }])
;